import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBxixJOzjxijqAvvipVzCKbd0_iECAeSfc",
  authDomain: "theory-dev-d6102.firebaseapp.com",
  databaseURL: "https://theory-dev-d6102.firebaseio.com",
  projectId: "theory-dev-d6102",
  storageBucket: "theory-dev-d6102.appspot.com",
  messagingSenderId: "1051256441075",
  appId: "1:1051256441075:web:15feddfd4952e6cbc18f86",
  measurementId: "G-63W9S8JG58"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider(); //enable google-signin pop-up
provider.setCustomParameters({ promt: "selected_account" });
export const signInWithGoogle = () => auth.signInWithPopup(provider);
export default firebase;
